import { render, staticRenderFns } from "./PaymentArticles.vue?vue&type=template&id=ce9bbf04"
import script from "./PaymentArticles.vue?vue&type=script&lang=ts"
export * from "./PaymentArticles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports